import { connectConfigure } from "instantsearch.js/es/connectors";
export const useAisConfigure = (widgetParams) => {
  const renderConfigure = (_, __) => {
    return () => {
    };
  };
  const customConfigure = connectConfigure(renderConfigure);
  return { ...customConfigure(widgetParams), $$widgetParams: widgetParams };
};
